<script setup lang="ts">
import Notify from './notify.vue';
import { useNotifyStore } from '@/storage/notify';

defineOptions({ name: 'XomNotify' });
const emits = defineEmits<{ (evt: 'close', visible?: boolean): void; (evt: 'ok'): void }>();
const n = useNotifyStore();

function onToggleSound() {
  const willEnable = !n.soundEnabled;
  n.toggleSound(willEnable);
  if (willEnable) {
    try {
      const audio = new Audio('/notify/notify.mp3');
      audio.volume = 1;
      audio.play().catch(() => {
        /* 自动播放被浏览器策略阻止时忽略 */
      });
    } catch {
      /* 忽略 */
    }
  }
}
</script>

<template>
  <div class="xom-notify">
    <a-tabs centered>
      <a-tab-pane key="1">
        <template #tab>
          <span>未读消息列表</span>
        </template>
        <template #default>
          <notify @close="emits('close')" />
        </template>
      </a-tab-pane>
    </a-tabs>
    <span
      class="notify-popover-sound"
      :class="{ 'notify-popover-sound--on': n.soundEnabled }"
      @click.stop="onToggleSound()"
    >
      <img v-if="n.soundEnabled" src="/notify/unmuted.svg" alt="unmuted" />
      <img v-else src="/notify/muted.svg" alt="muted" />
    </span>
  </div>
</template>

<style scoped lang="scss">
@use '@inn/assets/scss/vars';

.xom-notify {
  position: relative;
  width: 300px;
  height: 60vh;

  :deep(.#{vars.$ant-prefix}-tabs-nav) {
    margin: 0;
  }
}

.notify-popover-sound {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--xom-color-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;

  img {
    width: 18px;
    height: 18px;
    opacity: 0.6;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover {
    background-color: var(--xom-color-fill-tertiary);
  }

  &--on img {
    opacity: 1;
  }
}
</style>
